import Vue from 'vue'
import Vuex from 'vuex'
import  getters from './getters' 
import  actions from './actions'
import  mutations from './mutations'
import {getLStorage} from '../utils/util'
Vue.use(Vuex)


// 首先声明一个需要全局维护的状态 state
const state = {
    version:5.2,
    isMaster:JSON.parse(getLStorage("isMaster"))||false,
    isAdmin:JSON.parse(getLStorage("isAdmin"))||false,
    userId:getLStorage("userId")||'',
    organizationId:getLStorage("organizationId")||'',
    companyList:JSON.parse(getLStorage("companyList"))||[],
    companyName:getLStorage("companyName")||'',
    companyLogo:getLStorage("companyLogo")||'',
    name:getLStorage("name")||'',
    roleName:getLStorage("roleName")||'',
    mobile:getLStorage("mobile")||'',
    departId:getLStorage("departId")||'',
    companyIndex:getLStorage("companyIndex")||0,
    projectList:JSON.parse(getLStorage("projectList"))||[],
    xfShow:JSON.parse(getLStorage("xfShow"))||false,   //是否续费页面展示
    auditShow:JSON.parse(getLStorage("auditShow"))||false,//是否等待审核页面展示
}

// 注册上面引入的各大模块
const store = new Vuex.Store({
    state,    // 共同维护的一个状态，state里面可以是很多个全局状态
    getters,  // 获取数据并渲染
    actions,  // 数据的异步操作
    mutations  // 处理数据的唯一途径，state的改变或赋值只能在这里
})
 
export default store  // 导出store并在 main.js中引用注册。



// WEBPACK FOOTER //
// ./src/store/index.js